<template>
  <review :is-details="true"></review>
</template>

<script>
  import review from './review';

  export default {
    name: 'enterpriseInfoReviewDetails',
    components: { review }
  };
</script>

<style scoped>
</style>